import React, { useState, useEffect } from 'react';
import { Database, UploadCloud, History, ShieldCheck, Play, HardDrive, RefreshCw } from 'lucide-react';
import axios from 'axios';
import toast from 'react-hot-toast';

const BackupManager = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [backupHistory, setBackupHistory] = useState([]);

  // دالة لتشغيل الباك أب يدويًا
  const handleStartBackup = async () => {
    setIsProcessing(true);
    const loadId = toast.loading("Connecting to Dropbox & Exporting Database...");
    
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: { 'Authorization': `Bearer ${token}` }
      };
      
      const res = await axios.post('/api/admin/backup/run', {}, config);
      
      toast.success(res.data.message || "Backup Engine Started in Background!", { id: loadId });
      // تحديث الهيستوري بعد ثواني
      setTimeout(fetchHistory, 5000);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Backup Failed", { id: loadId });
    } finally {
      setIsProcessing(false);
    }
  };

  // دالة وهمية لجلب الهيستوري (ممكن تربطها بـ API لاحقاً)
  const fetchHistory = () => {
    // هنا ممكن تنادي API بيقرأ من جدول backup_logs
    setBackupHistory([
      { id: 1, name: `manual_backup_${new Date().toISOString().slice(0,10)}.sql`, date: new Date().toLocaleString(), status: 'SUCCESS' }
    ]);
  };

  return (
    <div className="p-8 bg-[#f3f4f6] min-h-screen font-black uppercase text-[11px]">
      <div className="max-w-4xl mx-auto space-y-6">
        
        {/* Header Card */}
        <div className="bg-white rounded shadow-xl p-8 border-t-4 border-[#1a3353]">
          <div className="flex justify-between items-center border-b pb-6 mb-8">
            <div className="flex items-center gap-4">
              <div className="bg-blue-100 p-3 rounded-lg text-[#1a3353]">
                <Database size={24}/>
              </div>
              <div>
                <h2 className="text-lg text-[#1a3353] font-black tracking-tighter">Disaster Recovery Console</h2>
                <p className="text-gray-400 text-[9px]">Manage your database snapshots and cloud synchronization</p>
              </div>
            </div>
            <div className="flex items-center gap-2 bg-green-50 text-green-700 px-4 py-2 rounded-full border border-green-100 animate-pulse">
              <ShieldCheck size={14}/> System Secure
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-4">
            {/* Cloud Status */}
            <div className="p-6 bg-slate-50 rounded border border-dashed border-gray-300 relative overflow-hidden group">
              <div className="absolute top-0 right-0 p-2 opacity-10 group-hover:scale-110 transition-transform">
                <UploadCloud size={80}/>
              </div>
              <h4 className="text-blue-900 mb-4 flex items-center gap-2 font-black">
                <HardDrive size={16}/> Cloud Connectivity
              </h4>
              <div className="space-y-2 relative z-10">
                <div className="flex justify-between"><span>Provider:</span> <span className="text-blue-600 font-black">DROPBOX (App Folder)</span></div>
                <div className="flex justify-between"><span>Remote Name:</span> <span className="text-gray-600 font-black">remote_drive</span></div>
                <div className="flex justify-between border-t pt-2 mt-2">
                   <span>Storage Status:</span> 
                   <span className="text-green-600">CONNECTED</span>
                </div>
              </div>
            </div>

            {/* Action Area */}
            <div className="flex flex-col justify-center space-y-4">
              <button 
                disabled={isProcessing}
                onClick={handleStartBackup}
                className={`w-full py-5 rounded shadow-lg font-black flex items-center justify-center gap-3 transition-all active:scale-95
                ${isProcessing ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#1a3353] hover:bg-black text-white'}`}
              >
                {isProcessing ? <RefreshCw className="animate-spin" size={20}/> : <Play size={20} fill="white"/>}
                {isProcessing ? "PROCESSING BACKUP..." : "RUN MANUAL CLOUD BACKUP"}
              </button>
              <p className="text-[9px] text-gray-400 text-center italic">
                * This process will create a full SQL dump and upload it to your linked Dropbox account.
              </p>
            </div>
          </div>
        </div>

        {/* History Table */}
        <div className="bg-white rounded shadow-xl overflow-hidden border-t-4 border-orange-500">
           <div className="p-4 bg-slate-50 border-b flex justify-between items-center">
              <h3 className="text-blue-900 flex items-center gap-2 font-black italic">
                <History size={16}/> Recent Backup Activities
              </h3>
           </div>
           <table className="w-full text-left border-collapse">
              <thead className="bg-gray-50 text-gray-400 text-[9px] border-b">
                <tr>
                  <th className="p-4">Backup File Name</th>
                  <th className="p-4">Execution Date</th>
                  <th className="p-4 text-center">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y text-gray-600">
                {backupHistory.length > 0 ? backupHistory.map(log => (
                  <tr key={log.id} className="hover:bg-blue-50/50">
                    <td className="p-4 font-mono text-blue-800">{log.name}</td>
                    <td className="p-4">{log.date}</td>
                    <td className="p-4 text-center">
                      <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-[9px]">{log.status}</span>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="3" className="p-10 text-center text-gray-300 italic font-black">No recent backup logs found.</td>
                  </tr>
                )}
              </tbody>
           </table>
        </div>
      </div>
    </div>
  );
};

export default BackupManager;